import { render, staticRenderFns } from "./StudentSnackbar.vue?vue&type=template&id=0e4ed046"
import script from "./StudentSnackbar.ts?vue&type=script&lang=ts&external"
export * from "./StudentSnackbar.ts?vue&type=script&lang=ts&external"
import style0 from "./StudentSnackbar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports